import CardWithDoughnutChartVertical from "./CardWithDoughnutChartVertical/CardWithDoughnutChartVertical";
import ComparisonChart from "./ComparisonChart";

const PksProductionComponent = {
  CardWithDoughnutChartVertical,
  ComparisonChart,
};

export default PksProductionComponent;
